import React, { useState } from "react";
import { useProductStore } from "../../store/useProductStore";
import { useAuthStore } from "../../store/useAuthStore";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader/Loader";
import ConfirmDialog from "../../components/Dialog/ConfirmDialog";

const ProductModal = ({ closeModal, distributorId=null }) => {
  console.log("distributorId", distributorId);
  const { isLoading, createOrder } = useProductStore();
  const { user } = useAuthStore();
  const [dialogVisible, setIsDialogVisible] = useState(false);

  const navigate = useNavigate();

  const cartData = JSON.parse(localStorage.getItem("product_data")) ? 
                  JSON.parse(localStorage.getItem("product_data")).filter(value => value.ordered_quantity > 0) : 
                  [];

  const calculateTotalPrice = () => {
    let totalPrice = 0;
    let totalProduct = 0;
    cartData.filter(value => value.ordered_quantity > 0).forEach((item) => {
      // totalPrice += item.default_mrp * item.ordered_quantity;
      const itemTotal = item.default_mrp * item.ordered_quantity * item.no_of_sets;
      const discount = itemTotal * (item?.discount_percent ?? 0) / 100;
      totalProduct += (item.ordered_quantity * item.no_of_sets || 0);
      totalPrice += itemTotal - discount;
    });
    return { totalPrice : totalPrice.toFixed(2), totalProduct};
  };

  const handleCreateOrder = async () => {
    if (cartData.length === 0) {
      toast.error(
        "Your cart is empty. Please add products before confirming the order.", {toastId: 'errorMessageCreateOrder'}
      );
      return;
    }

    // Extract only the product_id and ordered_quantity from the cart
    const orderData = cartData.filter(value => value.ordered_quantity > 0).map((item) => ({
      product_id: item.product_id,
      ordered_quantity: item.ordered_quantity,
    }));

    try {
      const body = {
        distributor_id: distributorId ? distributorId : user.userDataObj.user_id,
        order_details: orderData,
      };

      if (distributorId) {
        body.added_by_type = "ZONAL_MANAGER"
      }
      const { status, message } = await createOrder(body);
      if (status) {
        toast.success(message, {toastId: 'successMessageOrderData'});
        closeModal(false);
        navigate("/product-list");
        window.location.reload();
      } else {
        toast.error(message, {toastId: 'errorMessage'});
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again later.", {toastId: 'errorMessageCreateOrder'});
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-40">
      <div className="bg-white rounded-lg w-full max-w-4xl">
        <div className="p-6">
          <h2 className="text-2xl font-semibold text-teal-600 mb-4 text-center">
            Review Cart
          </h2>

          <div className="overflow-auto max-h-[350px]">
            <table className="w-full mb-4">
              <thead>
                <tr className="bg-emerald-200">
                  <th className="p-2 text-left">Part Number</th>
                  <th className="p-2 text-left">Size</th>
                  <th className="p-2 text-left">Make</th>
                  <th className="p-2 text-left">MRP Per Set</th>
                  <th className="p-2 text-center">Sets</th>
                  <th className="p-2 text-left">Billing Value</th>
                </tr>
              </thead>
              <tbody>
                {cartData.map((item, index) => (
                  <tr key={index} className="border-b">
                    <td className="p-2">{item.part_no}</td>
                    <td className="p-2">{item.size}</td>
                    <td className="p-2">{item.make}</td>
                    <td className="p-2">₹ {item.default_mrp}</td>
                    <td className="p-2 text-center">{item.ordered_quantity * item.no_of_sets}</td>
                    <td className="p-2">
                    ₹ {((item.default_mrp * item.ordered_quantity * item.no_of_sets) - 
                          ((item.default_mrp * item.ordered_quantity * item.no_of_sets) * (item?.discount_percent ?? 0) / 100)
                        ).toFixed(2)}
                    </td>
                  </tr>
                ))}
                <tr className="text-teal-800 font-bold" >
                  <td colSpan={4} className="p-2">Total</td>
                  <td className="p-2 text-center">{calculateTotalPrice().totalProduct}</td>
                  <td className="p-2">₹ {calculateTotalPrice().totalPrice}</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* <div className="space-y-2">
            <div className="flex justify-evenly text-teal-800 font-bold">
              <span className="font-semibold">Total Billing Price</span>
              <span>₹ {calculateTotalPrice().totalPrice}</span>
            </div>
          </div> */}

          {isLoading ? (
            <Loader />
          ) : (
            <div className="flex justify-center gap-4 mt-6">
              {cartData.length > 0 && (
                <button
                  onClick={() => setIsDialogVisible(true)}
                  className="px-12 py-2 bg-teal-600 text-white rounded hover:bg-teal-700"
                >
                  Confirm
                </button>
              )}
              <button
                onClick={() => closeModal(false)}
                className="px-12 py-2 bg-teal-600 text-white rounded hover:bg-teal-700"
              >
                Close
              </button>
            </div>
          )}
        </div>
      </div>

      <ConfirmDialog
        isOpen={dialogVisible}
        setIsOpen={setIsDialogVisible}
        handler={handleCreateOrder}
        title="Confirmation"
        message="Are you sure you would like to confirm your order ?"
        position="center"
      />
    </div>
  );
};

export default ProductModal;